import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment";
import { CarouselComponent, OwlOptions } from "ngx-owl-carousel-o";
import { ToastrService } from "ngx-toastr";
import { AuthServiceService } from "src/app/shareModule/services/auth-service.service";
import { LocalServiceService } from "src/app/shareModule/services/local-service.service";
import { environment } from "src/environments/environment";
import { Location } from "@angular/common";
import { TemplateRefBulletinService } from "./bulletin/template-ref-bulletin.service";
import { ModalService } from "src/app/shareModule/services/modal.service";
import { CommonService } from "src/app/shareModule/services/common.service";
import { RoleService } from "src/app/shareModule/services/roles/role.service";
import { AppState } from "src/app/shareModule/states/app.state";
import { select, Store } from "@ngrx/store";
import { loadNews, selectNews } from "src/app/shareModule/states/news";
import { FormNewComponent } from "./form-new/form-new.component";
import { SeoService } from "src/app/shareModule/services/seo.service";
import { Subject, takeUntil } from "rxjs";
import { AddComparisionArticleComponent } from "src/app/add-comparision-article/add-comparision-article.component";

@Component({
  selector: "app-news",
  templateUrl: "./news.component.html",
  styleUrls: ["news.component.scss"],
})
export class NewsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild('formNew') FormNewComponent: FormNewComponent;

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private myModalService: ModalService,
    private local: LocalServiceService,
    private location: Location,
    public commonService: CommonService,
    private templateRefService: TemplateRefBulletinService,
    public roleService: RoleService,
    private store: Store<AppState>,
    private seoService: SeoService,
    private cdr: ChangeDetectorRef,
    @Inject("WINDOW") private window: any,
  ) {
    this.seoService.update({
      title: 'News',
      description: 'Stay updated with the latest news, articles and community discussions. Get insights on lifestyle, business trends and local happenings.',
      main_title: ' | BEST SERVICES SG'
    })
    this.seoService.updateSchema('news')
  }

  mainCategories = ["All", "Lifestyle", "Business", "Gossip", "Forum Posts"];
  activeMainHashtag: string = "All";
  newPolling: any = {};
  activeIndexPoll: number = 1;
  showFloatingMenu: boolean = false;
  imgUrl: string = environment.ImageUrl;
  activeTab: string = "Forum";
  menu: boolean = false;
  openTag: boolean = false;
  openTags: boolean = true;
  openBulletin: boolean = true;
  openThreads: boolean = false;
  hashtags: any = [];
  cardDesc: boolean = false;

  ngOnInit(): void {
    this.initArticleHashtag();
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.appUserId = user.id;
        this.isLogin = 1;
      } else {
        this.isLogin = 0;
      }
    });
  }

  public openAddComparisonArticle(){
    this.modalRef =  this.modalService.open(AddComparisionArticleComponent, {size: 'md'})
    this.modalRef.hidden.subscribe(()=>{
      
    })
  }
  ngAfterViewInit(): void {

    this.route.queryParams.subscribe((res: any) => {
      if (res.category) {
        this.filterByCategory(res.category)
      } else {
        this.getNewsList();
      }
    });



    this.getLatestNews()
    this.updateOwlOptions();

    this.store.pipe(select(selectNews), takeUntil(this.destroy$)).subscribe((response: any) => {
      if (response && Array.isArray(response.data)) {
        this.banners = structuredClone(response);
        this.banners?.data?.map((item: any) => {
          if (item.slug == "null") {
            item.slug = item.id;
          }
        });
        this.get_bottom_banner_response = response;
        this.get_bottom_banner_response_length = response.length;
        this.get_bottom_banner_response_latest = response;
        this.cdr.detectChanges();
      }
    });
  }

  openBulletinModal() {
    if (this.isLogin == 0) {
      return this.toastr.error("Please Login First !");
    }
    const signinPopup = this.templateRefService.getBulletinPopup();
    if (signinPopup) {
      this.myModalService.open(signinPopup, {
        windowClass: "bulletin-form",
      });
    }
  }
  initArticleHashtag() {
    this.auth.getArticlesHashtag()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.hashtags = response.body.filter((hashtag: string) => !/^#[0-9A-Fa-f]{2}$/.test(hashtag) && !/^#[0-9A-Fa-f]{6}$/.test(hashtag));
      });
  }

  mainHashtagChange(event: any, value: string) {
    event.preventDefault();

    if (this.activeMainHashtag == value) this.activeMainHashtag = "";
    else this.activeMainHashtag = value;
  }
  @ViewChild("selectRelateArticle") selectRelateArticle!: ElementRef;

  @Input() selectedHashtag: any = "";
  @ViewChild("owlElement") owlElement: CarouselComponent;
  @ViewChild("detailBlog") detailBlog: ElementRef;
  @Input() shop_template: string = "default";

  get_bottom_banner_response: any = [{ image: "" }];
  get_bottom_banner_response_latest: any = [];
  // imgUrl = environment.ImageUrl;
  get_bottom_banner_response_length: any = 0;
  enc_app_user_id: string = "";
  isMarketplace: boolean = false;
  detail: any = {};
  baseUrlImage = environment.ImageUrl;
  isLogin: any = 0;
  appUserId: any = 0;

  ckEditorText: string = "";

  categories: any = ["All", "SG News", "Promotions", "Funny", "Business", "Food", "TGIF", "Self-Enlightenment", "Home Improvement"];
  categoryIconMap = {
    All: "list-check",
    "SG News": "newspaper",
    Promotions: "rectangle-ad",
    Funny: "music",
    Business: "business-time",
    Food: "utensils",
    TGIF: "shopping-cart",
    "Self-Enlightenment": "shopping-cart",
    "Home Improvement": "shopping-cart",
  };
  category: string = this.categories[0];
  isPopular: boolean = false;
  carouselOptions: any = {
    slidesPerView: "auto",
    pagination: false,
  };
  private modalRef: any;

  selectedArticleRelate: any = {};
  listArticlesRelated: any = [];
  bottomBannerTarget: any = null;

  selectConfig = {
    ajax: {
      url: environment.baseUrlAdmin + "get_bottom_banner_for_related",
      dataType: "json",
      delay: 250,
      data: (params: any) => {
        return {
          q: params.term, // search term
          exceptId: this.selectedArticleRelate.id,
        };
      },
      processResults: (data: any) => {
        return {
          results: data.body.map((item: any) => ({
            id: item.id,
            text: `${item.title} ${item.related > 0 ? "+" + item.related : ""}`,
          })),
        };
      },
      cache: true,
    },
    minimumInputLength: 1,
    placeholder: "Select Article",
  };

  // ngOnChanges(changes: any) {
  //   const value = changes?.selectedHashtag?.currentValue;
  //   this.get_bottom_banner(1, value == "All" ? "" : value);
  // }

  goBack() {

    this.commonService.goBack();
  }
  defaultOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: false,
    navSpeed: 700,
    smartSpeed: 4500,
    autoplayHoverPause: true,
    slideTransition: "linear",
    navText: ['<i id="prev-btn" class="prev-btn"></i>', '<i id="next-btn" class="next-btn"></i>'],
    items: 3,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      740: {
        items: 3,
      },
      // 940: {
      //   items: 4,
      // },
    },
    nav: true,
  };

  mobileOptions: OwlOptions = {
    ...this.defaultOptions,
    nav: false,
    dots: true,
  };
  banners: any = {
    data: []
  };

  customOptions: OwlOptions = this.defaultOptions;

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.updateOwlOptions();
  }

  updateOwlOptions() {
    if (this.window?.innerWidth < 600) {
      this.customOptions = this.mobileOptions;
    } else {
      this.customOptions = this.defaultOptions;
    }
  }

  getPages() {
    this.local.getPages(this.banners?.currentPage, this.banners?.lastPage);
  }

  public getNewsList(page = 1, hashtag = "", pageSize = 12) {
    this.store.dispatch(
      loadNews({
        adminId: 0,
        isAdmin: false,
        page: page,
        isPopular: this.isPopular ? 1 : 0,
        category: this.category === "All" ? "" : this.category,
        hashtag: hashtag,
        pageSize: pageSize,
      })
    );
  }

  protected latestNews: any = []
  public getLatestNews() {

    this.auth.get_bottom_banner({
      isPopular: 0,
      pageSize: 15
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.latestNews = response?.body?.data
        this.cdr.detectChanges();
      })
  }

  convertDate(value: number) {
    let date = value;

    return moment.unix(value).format("MMMM D, YYYY");
  }

  checkShopAndEmpty() {
    return this.window?.location?.href?.includes("/mobile/") && this.get_bottom_banner_response_length < 1;
  }

  navigateToUrl(url: string): void {
    this.window?.open(url, "_blank");
  }

  onEditorChange(event: any) {
    // this.ckEditorText = event.editor.getData();
  }

  openModalBlogForm(item: any = { text: "", category: "" }) {
    this.FormNewComponent.openModalBlogForm(item)
  }
  optionsRelated = [];
  openModalRelate(item: any = {}, isRemove = false) {
    this.FormNewComponent.openModalRelate(item, isRemove)
  }

  editBlog(item: any) {
    this.openModalBlogForm(item);
  }


  deleteBlog(id: number) {
    this.local.alertConfirm({}).then((resp: any) => {
      if (resp.isConfirmed) {
        this.auth.delete_bottom_banner({ bottomBannerId: id }).subscribe(
          (response: any) => {
            this.modalService.dismissAll();
            this.getNewsList();
            // this.bottom_banner_image_url_show = 0;
            this.toastr.success(response.message);
          },
          (e) => {
            this.toastr.error(e.error.message);
          }
        );
      }
    });
  }

  hasChecked(data: any) {
    return data.filter((row: any) => row.userId == this.appUserId).length > 0;
  }

  likeHandle(bottomBannerId: number, data: any) {
    if (this.isLogin == 0) {
      return this.toastr.error("Please Login First !");
    }
    const payload = {
      userId: this.appUserId,
      bottomBannerId: bottomBannerId,
    };

    if (this.hasChecked(data.bottomBannerLikes)) data.bottomBannerLikes = data.bottomBannerLikes.filter((row: any) => row.userId != this.appUserId);
    else data.bottomBannerLikes = [...data.bottomBannerLikes, payload];

    this.auth.likes_bottom_banner(payload).subscribe(() => {
      this.getNewsList();
    });
  }

  filterByCategory(value: string) {
    this.category = value;
    this.location.replaceState(`/news?category=${value}`)
    this.getNewsList();
  }

  prev() {
    const nextButton = document.querySelector(".prev-btn") as HTMLElement;
    if (nextButton) {
      nextButton.click();
    }
  }

  next() {
    const nextButton = document.querySelector(".next-btn") as HTMLElement;
    if (nextButton) {
      nextButton.click();
    }
  }

  removeHtmlTags(text: string): string {
    return text ? text.replace(/<[^>]*>/g, "") : "";
  }
  formatText(text: string, length?: number): string {
    const cleanText = this.removeHtmlTags(text);
    return cleanText;
  }

  shortText(cleanText: string, length: number) {
    return cleanText.length > length ? cleanText.substr(0, length) + '...' : cleanText;
  }

  public diamond: number = 0;

  public addDiamonds(modal, article) {
    if (this.isLogin == 0) {
      return this.toastr.error("Please Login First !");
    }
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: "sm",
      ariaLabelledBy: "modal-basic-title",
      backdrop: "static",
      windowClass: "my-modal sm",
    });
    this.selectedArticleRelate = article;
  }

  public submitAddDiamonds() {
    this.auth
      .addNewsDiamond({
        newsId: this.selectedArticleRelate.id,
        diamonds: this.diamond,
        type: "DIAMONDS-ADD",
      })

      .subscribe(
        (response: any) => {
          this.modalService.dismissAll();
          this.toastr.success(response.message);
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
